import React, { useState } from "react";

const ReservationDetailsPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showReservationDetailsPopup, setShowReservationDetailsPopup] =
      useState<boolean>(false);

    const reservationDetailsToggleHandler = () => {
      setShowReservationDetailsPopup(!showReservationDetailsPopup);
    };

    return (
      <Component
        showReservationDetailsPopup={showReservationDetailsPopup}
        reservationDetailsToggleHandler={reservationDetailsToggleHandler}
        {...props}
      />
    );
  };

export default ReservationDetailsPopupHOC;
